import { ContentView } from "./views/ContentView";

import "./App.css";

function App() {
  return <ContentView />;
}

export default App;
